
const pendingIcon = () => {
  return (
    <div>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="8" fill="#FA880D" fill-opacity="0.1"/>
<rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#FA880D" stroke-opacity="0.2"/>
<path d="M27 10V13C27 16.866 23.866 20 20 20M13 10V13C13 16.866 16.134 20 20 20M20 20C23.866 20 27 23.134 27 27V30M20 20C16.134 20 13 23.134 13 27V30" stroke="#FA880D" stroke-width="1.5"/>
<path d="M12 10H28M28 30H12" stroke="#FA880D" stroke-width="1.5" stroke-linecap="round"/>
</svg>

    </div>
  )
}

export default pendingIcon